import { createActions } from 'redux-actions'

/**
 * @see app/components/Modal
 */
export const { modal }: any = createActions({
  MODAL: {
    SHOW: (children, restProps) => ({ children, restProps }),
    HIDE: undefined,
  },
})
